import { useRef, useState, useEffect } from "react";
import * as yup from "yup";
import Common from "../../../helper/common";
import { respEnum } from "../../../constants/appConstant";
import { Formik } from "formik";
import { FormikInput } from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const formikValidation = yup.object({
  oldPassword: yup
    .string()
    .trim()
    .min(8)
    .max(15)
    .required("Old Password is Required"),
  newPassword: yup
    .string()
    .trim()
    .min(8)
    .max(15)
    .required("New Password is Required"),
  confirmPassword: yup
    .string()
    .trim()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is Required"),
});

const ChangePassword = ({ onClose, open, setOpen }) => {
  const formikRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    try {
      const { confirmPassword, ...payload } = d;

      let response = await Common.ApiService.getInstance().request(
        "UpdateApplicationUserPassword",
        payload,
        "POST"
      );

      action.setSubmitting(false);
      if (response.status === respEnum.Success) {
        Common.SweetAlert.alert(response.message);
        setOpen(false);
        onClose?.();
        if (!onClose) {
          navigate("/app/profile", { replace: true });
        }
      }
    } catch (err) {
      console.error("Password change failed:", err);
      Common.SweetAlert.alert("Something went wrong!");
      action.setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        setOpen(isOpen);
        if (!isOpen) {
          onClose?.();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-base font-medium">
            Update Password
          </DialogTitle>
        </DialogHeader>

        <div className="text-sm text-default-500 space-y-2 max-h-[450px] overflow-y-auto pr-2">
          <Formik
            innerRef={formikRef}
            onSubmit={onSubmitData}
            initialValues={FormikInitialValues}
            validationSchema={formikValidation}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(formikProps) => (
              <div className="flex flex-col gap-4 mt-4">
                <FormikInput
                  formikProps={formikProps}
                  name={"oldPassword"}
                  label={"Old Password"}
                  placeholder={"Enter Old Password"}
                  type={"password"}
                />
                <FormikInput
                  formikProps={formikProps}
                  name={"newPassword"}
                  label={"New Password"}
                  placeholder={"Enter New Password"}
                  type={"password"}
                />
                <FormikInput
                  formikProps={formikProps}
                  name={"confirmPassword"}
                  label={"Confirm Password"}
                  placeholder={"Confirm New Password"}
                  type={"password"}
                />
              </div>
            )}
          </Formik>
        </div>

        <DialogFooter className="mt-8 gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              setOpen(false);
              onClose?.();
            }}
          >
            Close
          </Button>

          {isFormikInitialized && formikRef.current && (
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                formikRef.current?.handleSubmit();
              }}
            >
              {formikRef.current.isSubmitting ? "Saving..." : "Update"}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChangePassword;
